import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места SEO-баннера в футере выдачи.
 * Должны совпадать с легаси-размещением Adfox (SeoTopBannersContainer).
 */
const PLACE = 'footer';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 560 };

/**
 * Параметры места SEO-баннера в футере (desktop).
 */
export function useSeoTopParameters(): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: P_PARAMS,
      sizes: SIZES,
      position: null,
      galleryPosition: null,
      isSp: false,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [],
  );
}
